export default [
  { name: 'Program', prop: 'program_id', type: 'autocomplete', references: 'admin/programs', referenceProp: 'name' },
  { name: 'Question', prop: 'question_id', type: 'autocomplete', references: 'admin/questions', referenceProp: 'question' },
  { name: 'Starting week', prop: 'starting_week_number', type: 'number' },
  { name: 'Stop showing at the start of week', prop: 'ending_week_number', type: 'number' }
]
